import ajax from '../ajax'



//api/image/sign 获取签名
//post
//参数 filename

///api/image/finish 上传完回调请求
//参数 image_id

export function SignApi(data) {
    return ajax({
        method:'post',
        url: '/api/image/sign',
        data
    })
}


///api/image/exists
export function ExistsApi(data) {
    return ajax({
        method:'post',
        url: '/api/image/exists',
        data
    })
}



//上传完的回调
export function completeUploadApi(params) {
    return ajax({
        method:'get',
        url: '/api/image/finish',
        params
    })
}

//开始上传
export function startUploadApi(url,FormData) {
    return ajax({
        method:'post',
        url: url,
        data:FormData
    })
}



///api/image/index
export function indexApi(params) {
    return ajax({
        method:'get',
        url: '/api/image/index',
        params
    })
}




export function EditApi(data) {
    return ajax({
        method:'post',
        url: '/api/image/edit',
        data
    })
}



///api/image/search
export function SearchApi(params) {
    return ajax({
        method:'get',
        url: '/api/image/search',
        params
    })
}




///api/image/info?id=1  大图的
export function InfoApi(params) {
    return ajax({
        method:'get',
        url: '/api/image/info',
        params
    })
}

//api/image/del
export function DelApi(data) {
    return ajax({
        method:'post',
        url: '/api/image/del',
        data
    })
}


// 权限管理  /api/user/status
export function StatusApi(params) {
    return ajax({
        method:'get',
        url: '/api/user/status',
        params
    })
}


//评图/api/image/set
export function SetApi(params) {
    return ajax({
        method:'get',
        url: '/api/image/set',
        params
    })
}



//api/image/staffscore

export function StaffscoreApi(data) {
    return ajax({
        method:'post',
        url: '/api/image/staffscore',
        data
    })
}


/////api/image/scorelist 图片列表
export function scorelistApi(params) {
    return ajax({
        method:'get',
        url: '/api/image/scorelist',
        params
    })
}
export function DownloadApi(params) {
    return ajax({
        method:'get',
        url: '/api/image/download',
        params
    })
}





export function GetstaffApi(data) {
    return ajax({
        method:'post',
        url: '/api/image/getstaff',
        data
    })
}






// WEBPACK FOOTER //
// ./src/api/work/index.js